@charset "UTF-8";

/* src/app/pages/initial-journey-modal/initial-journey-modal.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
h1,
h2,
h3,
h4,
h5,
h6,
label,
p,
b,
small,
span,
strong {
  margin: 0px;
  -webkit-font-smoothing: antialiased;
}
h1.cds-required::after,
h2.cds-required::after,
h3.cds-required::after,
h4.cds-required::after,
h5.cds-required::after,
h6.cds-required::after,
label.cds-required::after,
p.cds-required::after,
b.cds-required::after,
small.cds-required::after,
span.cds-required::after,
strong.cds-required::after {
  font-family: var(--cds-font-family);
  font-size: inherit;
  font-weight: inherit;
  color: var(--cds-danger-500);
  line-height: inherit;
  content: "*";
}
h1[class^=c-],
h2[class^=c-],
h3[class^=c-],
h4[class^=c-],
h5[class^=c-],
h6[class^=c-],
label[class^=c-],
p[class^=c-],
b[class^=c-],
small[class^=c-],
span[class^=c-],
strong[class^=c-] {
  color: var(--color);
}
b,
strong,
span {
  font-family: var(--cds-font-family);
}
h1 {
  font-family: var(--cds-font-family);
  font-size: 30px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h2 {
  font-family: var(--cds-font-family);
  font-size: 24px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h3 {
  font-family: var(--cds-font-family);
  font-size: 22px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h4 {
  font-family: var(--cds-font-family);
  font-size: 20px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h5 {
  font-family: var(--cds-font-family);
  font-size: 18px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h6 {
  font-family: var(--cds-font-family);
  font-size: 16px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
p {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-medium);
  line-height: 1;
}
p.bold {
  font-weight: bold;
}
label {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
small {
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host {
  display: flex;
  align-items: center;
  justify-content: stretch;
  flex-direction: column;
  box-shadow:
    0px 6px 6px -3px hsla(var(--cds-shadow-600-hsl), 0.12),
    0px 10px 14px 1px hsla(var(--cds-shadow-600-hsl), 0.09),
    0px 4px 18px 3px hsla(var(--cds-shadow-600-hsl), 0.08);
  width: 576px;
  padding: 24px 33px 23px;
  border-radius: 8px;
  background: var(--cds-background-main);
  gap: 26px;
}
:host > *:last-child {
  margin-bottom: 0;
}
:host(.acceptance-view) {
  width: 480px;
}
h2 {
  font-family: var(--cds-font-family);
  font-size: 30px;
  font-weight: 500;
  color: var(--cds-secondary-500);
  line-height: 1;
  text-align: center;
}
img {
  height: 300px;
  width: 90%;
}
img[src$=".gif"] {
  box-shadow:
    0px 7px 8px -4px hsla(var(--cds-shadow-600-hsl), 0.12),
    0px 12px 17px 2px hsla(var(--cds-shadow-600-hsl), 0.09),
    0px 5px 22px 4px hsla(var(--cds-shadow-600-hsl), 0.08);
}
p {
  font-size: 16px;
  text-align: center;
  line-height: 150%;
  padding: 0px 35px;
}
p ::ng-deep b {
  color: var(--cds-text-strong);
}
.text-scroll {
  scrollbar-color: var(--cds-border-accent) transparent;
  scrollbar-width: thin;
  overflow: auto;
  max-height: 350px;
}
.text-scroll::-webkit-scrollbar {
  width: 4px;
  height: 6px;
}
.text-scroll::-webkit-scrollbar-thumb {
  background: var(--cds-border-accent);
  border-radius: 4px;
}
.text-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.text-scroll:hover::-webkit-scrollbar-thumb {
  background: var(--cds-foreground-200);
}
.text-jump {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: 400;
  color: var(--cds-text-strong);
  line-height: 1;
  text-decoration: underline;
}
.button-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 22px;
}
::ng-deep .cds-links {
  color: var(--cds-primary-500) !important;
}
.text-accept-term {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: 400;
  color: var(--cds-text-medium);
  line-height: 1;
  line-height: 170%;
  text-align: justify;
  margin-right: 10px;
}
.text-accept-term ::ng-deep b,
.text-accept-term ::ng-deep a {
  color: var(--cds-text-medium) !important;
}
.text-accept-term ::ng-deep h3 {
  text-align: center;
}
::ng-deep .back-show:last-of-type {
  justify-content: unset !important;
}
.welcome {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.welcome-title {
  font-family: var(--cds-font-family);
  font-size: 16px;
  font-weight: 700;
  color: var(--cds-text-strong);
  line-height: 1;
  text-align: center;
  padding: 0;
}
.welcome-subtitle {
  font-family: var(--cds-font-family);
  font-size: 16px;
  font-weight: 400;
  color: var(--cds-text-medium);
  line-height: 1;
  text-align: center;
  line-height: 140%;
  padding: 0;
}
.welcome-consent {
  margin-top: 22px;
}
.link-terms {
  display: inline;
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-weight: 700;
  color: var(--cds-primary-500);
  text-decoration: underline;
  cursor: pointer;
}
.terms-view {
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.back-button {
  align-self: flex-start;
}
.terms-scroll {
  height: 430px;
  max-height: 430px;
}
/*# sourceMappingURL=initial-journey-modal.component.css.map */
